import type { EducationalDetailsDto } from '../../models/person/educationalDetailsDto';
import { requests } from '../httpClient';

export const Pmd = {
    getEducationAsync: () => requests.get(`Pmd`),
    saveEducationAsync: (data: EducationalDetailsDto) => requests.post(`Pmd`, data),
    updateEducationAsync: (data: EducationalDetailsDto) => requests.put(`Pmd`, data)
};
